module.exports = __webpack_public_path__ + "static/media/alq3.2ed59032.webp";